<template>
    <div>
        {{userid}}
        <button class="btn" @click.stop="details">点击</button>
    </div>
</template>

<script>
import { getWxSingleConfig, wxGetLocationH5, geoGetLocation } from "@/js/wxcopy.js";
export default {
    data(){
        return{
            userid:''
        }
    },  
    created() {
         $init((res) => {
            this.userid = this.$storage.getStorage('user_id');
            //  let confit = {
            //      share_friend_title:
            //          "A.O.史密斯AI-LiNK冷暖风水专业集成-项目案例",
            //      share_friend_desc: "中央空调·采暖·新风·全屋用水",
            //      share_img_url:
            //          "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/share_two_img.png",
            //      share_link: window.location.href,
            //  };
            //  getWxSingleConfig(confit);
            //  wxGetLocationH5();
         })
    },
    methods:{
        details(){
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                if (ua.match(/WxWork/i) == "wxwork") {
                    if (wx?.miniProgram?.getEnv) {
                        wx.miniProgram.getEnv(function (res) {
                            if (res.miniprogram) {
                                // 小程序环境下逻辑
                                alert("企业小程序环境下逻辑");
                            } else {
                                //非小程序环境下逻辑
                                alert("企业公众号下逻辑");
                            }
                        });
                    } else {
                        //企业微信环境下
                        alert('企业微信环境下');
                    }
                } else {
                    //判断是否是微信环境
                    //微信环境
                    wx.miniProgram.getEnv(function (res) {
                        if (res.miniprogram) {
                            // 小程序环境下逻辑
                            alert("小程序环境下逻辑");
                        } else {
                            //非小程序环境下逻辑
                            alert('公众号环境下逻辑');
                        }
                    });
                }
            } else {
                // 非微信环境逻辑
                alert("非微信环境逻辑");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.btn{
    width: 200px;
    height: 100px;
}
</style>